<script type="text/ecmascript-6">
    import DesignerQuestionHardwareHandle from "../DesignerQuestionHardwareHandle.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareHandle
        ],
        props: {
            title: {
                default() {
                    return 'Select Your Door Handle';
                }
            },
            helper_text: {
                default() {
                    return '';
                }
            },
            extra_text: {
              default() {
                return '';
              }
            },
        }
    }
</script>
